// extracted by mini-css-extract-plugin
export var content = "LandingTwoColumnListWithImageSection-module--content--63060";
export var groupContent = "LandingTwoColumnListWithImageSection-module--groupContent--fccb1";
export var heading = "LandingTwoColumnListWithImageSection-module--heading--c617f";
export var image = "LandingTwoColumnListWithImageSection-module--image--5cedd";
export var wrapper = "LandingTwoColumnListWithImageSection-module--wrapper--68236";